/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataNodataReturnGoodsDto } from './PageDataNodataReturnGoodsDto';
import {
    PageDataNodataReturnGoodsDtoFromJSON,
    PageDataNodataReturnGoodsDtoFromJSONTyped,
    PageDataNodataReturnGoodsDtoToJSON,
    PageDataNodataReturnGoodsDtoToJSONTyped,
} from './PageDataNodataReturnGoodsDto';

/**
 * 
 * @export
 * @interface ResponsePageDataNodataReturnGoodsDto
 */
export interface ResponsePageDataNodataReturnGoodsDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataNodataReturnGoodsDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataNodataReturnGoodsDto
     */
    message?: string;
    /**
     * 
     * @type {PageDataNodataReturnGoodsDto}
     * @memberof ResponsePageDataNodataReturnGoodsDto
     */
    data?: PageDataNodataReturnGoodsDto;
}

/**
 * Check if a given object implements the ResponsePageDataNodataReturnGoodsDto interface.
 */
export function instanceOfResponsePageDataNodataReturnGoodsDto(value: object): value is ResponsePageDataNodataReturnGoodsDto {
    return true;
}

export function ResponsePageDataNodataReturnGoodsDtoFromJSON(json: any): ResponsePageDataNodataReturnGoodsDto {
    return ResponsePageDataNodataReturnGoodsDtoFromJSONTyped(json, false);
}

export function ResponsePageDataNodataReturnGoodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataNodataReturnGoodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataNodataReturnGoodsDtoFromJSON(json['data']),
    };
}

export function ResponsePageDataNodataReturnGoodsDtoToJSON(json: any): ResponsePageDataNodataReturnGoodsDto {
    return ResponsePageDataNodataReturnGoodsDtoToJSONTyped(json, false);
}

export function ResponsePageDataNodataReturnGoodsDtoToJSONTyped(value?: ResponsePageDataNodataReturnGoodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataNodataReturnGoodsDtoToJSON(value['data']),
    };
}

